import { differenceInSeconds, secondsInWeek } from 'date-fns';
import { useFirebaseContext } from './useFirebaseContext';
import { getAuthIsLoggedIn } from '@/y-model/auth';
import { useSelector } from 'react-redux';
import { useGetSubscriptionsStatus, useUpdateSubscriptionToken } from '@/y-entities/notifications';
import { appStorageController } from '../../../storage';

export const useUpdateFirebaseToken = () => {
    const { token: firebaseToken, isLoading: tokenIsLoading } = useFirebaseContext();
    const [ updateSubscriptionToken ] = useUpdateSubscriptionToken();
    const isLoggedIn = useSelector(getAuthIsLoggedIn);
    const subscriptionId = appStorageController.get('subscriptionId') ?? '';
    const {
        data: isSubscribed,
        isLoading: getSubscriptionStatusRequestIsLoading,
    } = useGetSubscriptionsStatus(subscriptionId, { skip: !isLoggedIn });

    const isLoading = tokenIsLoading || getSubscriptionStatusRequestIsLoading;

    const tokenHasToBeUpdated = isLoggedIn
      && !isLoading
      && appStorageController.get('firebaseTokenLastUpdate')
      && isSubscribed;

    if (!tokenHasToBeUpdated) return;

    const updateTokenAfterTwoWeeks = () => {
        const token = firebaseToken;
        const lastUpdateDate = appStorageController.get('firebaseTokenLastUpdate');

        if (!token || !lastUpdateDate) return;

        const currentDate = Date.now();

        if (differenceInSeconds(lastUpdateDate, currentDate) > secondsInWeek * 2) {
            updateSubscriptionToken({ token, subscriptionId });
        }
    };
    updateTokenAfterTwoWeeks();
};
